import { Component, Signal } from "@angular/core";

import { toSignal } from "@angular/core/rxjs-interop";

import { CrossSell, ProductPageFacade } from "@hermes/states/product-page";
import { isNotNullOrUndefined } from "@hermes/utils-generic/helpers";

@Component({
    selector: "h-product-page-cross-sell",
    templateUrl: "./product-page-cross-sell.component.html",
    styleUrls: ["./product-page-cross-sell.component.scss"],
})
export class ProductPageCrossSellComponent {
    public crossSell: Signal<CrossSell | undefined>;

    constructor(private productPageFacade: ProductPageFacade) {
        this.crossSell = toSignal(
            this.productPageFacade.crossSell$.pipe(isNotNullOrUndefined()),
        );
    }
}
